module.exports = __webpack_public_path__ + "media/newstyle/images/icon-quadrado-6948f612ed826bdac4d7c45e6356dbc7.svg";